import { useEffect } from "react";
import { useAuth } from "./auth";
import mixpanel from "mixpanel-browser";

/**
 * Hook customizado para gerenciar tracking do Mixpanel
 * Separa a lógica de analytics do componente App
 */
export const useMixpanelTracking = () => {
  const { user, getTenantInfo } = useAuth();

  useEffect(() => {
    // Só executar tracking em produção e se o usuário existir
    if (process.env.NODE_ENV !== "production" || !user?.id) return;

    // Não fazer tracking do usuário de suporte
    if (user.userName === "SuporteD4C") return;

    const tenantInfo = getTenantInfo();

    try {
      mixpanel.identify(user.id);
      mixpanel.people.set({
        $name: user.userName,
        $email: user.email,
        $tenant: tenantInfo?.nome,
      });
    } catch (error) {
      console.warn("⚠️ Erro no tracking Mixpanel:", error);
    }
  }, [user?.id, user?.userName, user?.email, getTenantInfo]);
};